import { Link } from "react-router-dom";
import { Container, Row, Col, List } from "reactstrap";

const StateIndexListBanner = (props: any) => {
  return (
    <>
      <section className="page-banner">
        <div className="page-banner-wrap">
          <Container>
            <Row>
              <Col lg={12} xs={12}>
                <div className="heading-wrap">
                  <h1>Our State Office Bearers</h1>
                </div>
                <nav aria-label="breadcrumb">
                  <List className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/">Home</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      <Link to="/statemember/1">Our State Office Bearers</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      {props?.doctor_name}
                    </li>
                  </List>
                </nav>
              </Col>
            </Row>
          </Container>
        </div>
      </section>
    </>
  );
};

export default StateIndexListBanner;
